import React from 'react'
import { Calendar, Tag, Building2 } from 'lucide-react'
import { Container, Eyebrow, GradientButton, GhostButton } from '@/components/landing/design-system'
export default function FinalCTA() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 opacity-[0.6]"
        style={{ background: 'radial-gradient(60% 45% at 50% 20%, rgba(34,197,94,0.14), transparent 70%)' }} />
      <div className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide">
        <div className="relative rounded-3xl border border-white/10 bg-gradient-to-b from-white/[0.04] to-white/[0.01] p-8 md:p-12 lg:p-14 backdrop-blur-xl overflow-hidden">
          <div className="pointer-events-none absolute -top-20 -left-20 h-64 w-64 rounded-full bg-brand-gold/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 -right-20 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="relative flex flex-col items-center text-center gap-6 max-w-3xl mx-auto">
            <Eyebrow>Ready to build</Eyebrow>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-white leading-[1.05]">
              Power your trading business with <span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">enterprise-grade infrastructure.</span>
            </h2>
            <p className="text-base md:text-lg text-zinc-400 leading-relaxed">
              Deliver professional trading experiences through a fully-integrated AI trading platform designed for growth, scalability and white-label deployment.
            </p>
            <div className="flex flex-col sm:flex-row items-stretch gap-3 pt-2">
              <GradientButton href="/get-started" size="lg">
                <Calendar className="h-4 w-4" /> Schedule a demo
              </GradientButton>
              <GhostButton href="/plans" size="lg" trailingIcon>
                <Tag className="h-4 w-4" /> View pricing
              </GhostButton>
              <GhostButton href="/white-label" size="lg" trailingIcon>
                <Building2 className="h-4 w-4" /> Explore white-label
              </GhostButton>
            </div>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-[11px] text-zinc-500">
              <span className="inline-flex items-center gap-1.5"><span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> Multi-asset</span>
              <span>·</span><span>AI-integrated</span>
              <span>·</span><span>White-label ready</span>
              <span>·</span><span>Multi-tenant by design</span>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
